export default __webpack_public_path__ + "static/media/pulkkis_sm.b6a7165b.png";